module.exports = __webpack_public_path__ + "img/08.87661e30.jpg";